import type { ProfileUserDataBridgesTabProps } from './ProfileUserDataBridgesTab.types';
import type { ReactElement } from 'react';

import { Box, Flex, Grid } from '@rango-dev/whale';
import { Pagination } from '@rango-dev/whale/lab';
import React from 'react';

import usePagination from '../../../../hooks/usePagination';
import { usePaginationLabels } from '../../../../hooks/usePaginationLabels';
import { useWindowDimensions } from '../../../../hooks/useWindowDimensions';
import { ProfileUserDataProtocolCard } from '../PorfileUserDataProtocolCard';
import { ProfileUserDataEmptyState } from '../ProfileUserDataEmptyState';

const GRID_MIN_WIDTH = '300px';
const LOADING_COUNT = 8;

export function ProfileUserDataBridgesTab(props: ProfileUserDataBridgesTabProps): ReactElement {
  const { profileBridges, loading } = props;
  const { isMobile } = useWindowDimensions();
  const { paginatedItems, totalPages, page, setPage } = usePagination({
    items: profileBridges ?? [],
  });
  const paginationLabels = usePaginationLabels();

  if (loading) {
    return (
      <Grid
        columns={{ initial: '1', sm: `repeat(auto-fill, minmax(${GRID_MIN_WIDTH}, 1fr))` }}
        gap={{ initial: '4', md: '5' }}>
        {Array.from({ length: LOADING_COUNT }, (_, idx) => idx).map((idx) => (
          <ProfileUserDataProtocolCard type="bridge" key={`bridge-skeleton-${idx}`} loading />
        ))}
      </Grid>
    );
  }

  if (!profileBridges?.length) {
    return <ProfileUserDataEmptyState error={props.error} />;
  }

  const itemToRender = isMobile ? profileBridges : paginatedItems;

  return (
    <Flex direction="column" gap="5">
      <Grid
        columns={{ initial: '1', sm: `repeat(auto-fill, minmax(${GRID_MIN_WIDTH}, 1fr))` }}
        gap={{ initial: '4', md: '5' }}>
        {itemToRender.map((profileBridgeItem) => (
          <ProfileUserDataProtocolCard
            type="bridge"
            key={profileBridgeItem.swapper.title}
            data={profileBridgeItem}
          />
        ))}
      </Grid>
      {!isMobile && totalPages > 1 ? (
        <Box>
          <Pagination.Set
            showEdgePages
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
            labels={paginationLabels}
          />
        </Box>
      ) : null}
    </Flex>
  );
}
